import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-alumni-association',
  templateUrl: './alumni-association.component.html',
  styleUrls: ['./alumni-association.component.css']
})
export class AlumniAssociationComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner: any = {
    pagetitle: "Alumni Association",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Alumni Association",
  }
}
